module.exports = __webpack_public_path__ + "static/img/CgoRDGREnoCATiQxABRsx9XcDUQ361.a3dce99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CgoRDGREnoCATiQxABRsx9XcDUQ361.png
// module id = NW3J
// module chunks = 73